import React, { useState, useEffect } from "react";
import { Container, Col, Image, Row, Card } from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import pro2 from "../assets/img/pro2.png";
import { apiUrl } from "../commons/inFormTypes";
import { IPUrl } from "../commons/IPAddress";
import AllHeader from "../components/AllHeader";
import NotInfo from "../components/NotInfo";
import useCheckUser from "../custom-hooks/useCheckUser";
import { toast } from "react-toastify";
import axiosInstance from "../api/axiosInstance";
import BigLoader from "../components/BigLoader";

function Projects() {
  const [load, setLoad] = useState(false);
  const [seenFile, setSeenFile] = useState([]);
  const UserID = localStorage.getItem("UserId");
  const TokenId = localStorage.getItem("tokenId");
  const Mobile = localStorage.getItem("user_mobile");

  // Example usage of the custom hook
  useCheckUser(UserID); // Replace UserID with the actual user ID value

  useEffect(() => {
    setLoad(true);
    axiosInstance.post("GetProList").then((res) => {
      if (res.data.result === "true") {
        setSeenFile(res.data.data);
        setLoad(false);
      } else {
        toast.error(res.data.message, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });
      }
    });
  }, []);

  return (
    <div className="rgc-pages">
      <AllHeader>
        <span>پروژه های در حال انجام</span>
      </AllHeader>
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} className="rgc-title">
            <Row
              xs={1}
              md={2}
              className="justify-content-center justify-content-md-start g-4"
            >
              {load === false && seenFile.length === 0 ? (
                <NotInfo />
              ) : (
                seenFile.map((data, index) => {
                  return (
                    <Col xs={12} md={6} lg={4} key={index}>
                      <NavLink to={"../internalprojects/" + data.Id}>
                        <Card className="rgc-cards">
                          <Card.Img
                            variant="top"
                            src={
                              IPUrl + "/UploadedFile/Session/Ssn/" + data.Pic
                            }
                            className="p-3 rounded"
                          />
                          <Card.Body>
                            <Card.Title className="d-flex justify-content-between text-primary">
                              {data.Tittle}
                              <i className="fas fa-ellipsis-h"></i>
                            </Card.Title>
                            <Card.Text>
                              <i className="fas fa-pen"></i>
                              {data.Chekideh}
                            </Card.Text>
                          </Card.Body>
                        </Card>
                      </NavLink>
                    </Col>
                  );
                })
              )}
            </Row>
          </Col>
        </Row>
      </Container>
      <BigLoader loading={load} />
    </div>
  );
}

export default Projects;
